var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageNotFound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_123818",
    "data-name": "Group 123818",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 463.811,
    height: 333.823,
    viewBox: "0 0 463.811 333.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26249",
    "data-name": "Rectangle 26249",
    width: 463.811,
    height: 333.823,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26244",
    "data-name": "Rectangle 26244",
    width: 115.051,
    height: 115.052,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26246",
    "data-name": "Rectangle 26246",
    width: 47.844,
    height: 13.269,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26247",
    "data-name": "Rectangle 26247",
    width: 54.365,
    height: 54.365,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_123817",
    "data-name": "Group 123817",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123816",
    "data-name": "Group 123816",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123815",
    "data-name": "Group 123815",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20471",
    "data-name": "Path 20471",
    d: "M443.8,381.635c-29.256,0-424.8-.854-424.8-.9-.163-.384-50.213-61.726,12.81-125.86,31.227-31.778-28.676-72.948,0-108.3,49.121-60.55,97.724-26.45,138.214-43.479,7.154-3.006,14.333-7.844,21.519-15.269A80.016,80.016,0,0,1,204.768,76.85q1.091-.728,2.205-1.42a88.1,88.1,0,0,1,8.823-4.789q3.058-1.442,6.231-2.667h0a102.018,102.018,0,0,1,10.327-3.363,116.863,116.863,0,0,1,15.4-3.022q3.436-.447,6.927-.706c45.242-3.4,96.156,15.729,122.43,43.691,5.29,5.63,29.344,34.764,10.383,74.807-11.972,25.282,38.181,49.429,56,78.3,45.311,73.4.706,123,.295,123.954",
    transform: "translate(0 -48.55)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_123808",
    "data-name": "Group 123808",
    transform: "translate(229.857 85.252)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123807",
    "data-name": "Group 123807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123806",
    "data-name": "Group 123806",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20472",
    "data-name": "Path 20472",
    d: "M1275.831,508.987a57.9,57.9,0,0,1-4.413,9.418,57.527,57.527,0,0,1-107.026-25.155,56.513,56.513,0,0,1,.073-8.773,57.917,57.917,0,0,1,8.673-25.842c.024-.04.049-.077.073-.117A57.664,57.664,0,0,1,1206,434.034c1.4-.4,2.828-.752,4.263-1.045a57.2,57.2,0,0,1,31.171,2.3q2.063.75,4.029,1.638a57.123,57.123,0,0,1,23.311,19.246h0a57.728,57.728,0,0,1,9.2,20.87q.529,2.413.853,4.874a57.248,57.248,0,0,1-2.994,27.07",
    transform: "translate(-1164.257 -431.812)",
    fill: "#d7e5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20473",
    "data-name": "Path 20473",
    d: "M1248.321,463.252c-3.4,2.632-2.5,9.675-8.38,5.7s-9.576-6.127-11.241-2.664,3.546,5.361,2.174,9.135-4.164,4.173-7.106,1.074-3.03-6.083-7.8-5.984-6.8-1.862-6.569-5.44a5.034,5.034,0,0,0-.157-1.659c.024-.04.049-.077.073-.117a57.663,57.663,0,0,1,32.785-24.485c1.4-.4,2.828-.751,4.263-1.045a7.564,7.564,0,0,1,4.389,4.795c2.075,6.047,5.44,4.624,2.582,9.69s-1.682,6.308,1.438,7.238,6.717,2.237,6.226,4.705-9.282-3.579-12.681-.947",
    transform: "translate(-1200.364 -436.594)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20474",
    "data-name": "Path 20474",
    d: "M1564.6,693.865a57.89,57.89,0,0,1-4.413,9.418,57.188,57.188,0,0,1-16.068,17.635,6.564,6.564,0,0,1-4.28-1.687c-5.76-5.146,1.874-10.613,5.893-13.272s-3.444-3.541-7.207-8.724,5.047-12.206-.614-12.585-12.548-.746-13.7-6.812,4.8-4.816,3.761-9.927,3.884-6.066,9.154-4.609,5.919-2.427,12.45-.663,3.457,9.8,10.663,11.812,6.3,3.512,6.3,3.512a3.476,3.476,0,0,1,1.352.839,57.624,57.624,0,0,1-3.293,15.063",
    transform: "translate(-1453.031 -616.69)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20475",
    "data-name": "Path 20475",
    d: "M1624.749,575.137c-6.86.717-6.4-7.847-12.221-7.339-5.872.511-3.36-3.663-6.267-7.977s-12.712-1.975-10.72-6.339,7.466-.949,10.031-4.085,7.99-.148,7.99-.148a4.141,4.141,0,0,1,1.132.143s0,0,0,0a57.731,57.731,0,0,1,9.2,20.87q.528,2.413.853,4.874",
    transform: "translate(-1510.181 -525.031)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20476",
    "data-name": "Path 20476",
    d: "M1470.348,475.776s4.658-3.3.278-6.363-4.909-1.329-8.538-3.1-6.173.608-4.5,4.827,1.737,11.175,5.485,8.843,4.152-4.983,7.277-4.2",
    transform: "translate(-1399.255 -459.023)",
    fill: "#aec3ff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_20477",
    "data-name": "Path 20477",
    d: "M158.354,1592.889h20.058c1.075-.912-.744-2.982-2.644-3.122a11.715,11.715,0,0,0-3.062.362c-.276-3.666-1.852-20.146-7.793-19.485-6.679.742,0,7.258,1.888,11.116a91.69,91.69,0,0,1,3.549,8.889c-.542.118-1.1.233-1.677.338-.885-2.718-4.18-11.862-8.369-11.329-4.919.624-2.941,4.29.545,6.466,2.557,1.6,5.7,3.875,7.191,4.974a21.312,21.312,0,0,1-3.923.314c-3.436-.082-5.113.931-5.763,1.476",
    transform: "translate(-126.289 -1260.54)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20478",
    "data-name": "Path 20478",
    d: "M1702.363,1599.329h-18.631c-1-.847.691-2.77,2.456-2.9a10.892,10.892,0,0,1,2.844.336c.256-3.405,1.72-18.713,7.238-18.1,6.2.689,0,6.741-1.754,10.325a85.133,85.133,0,0,0-3.3,8.257c.5.109,1.025.216,1.558.314.822-2.525,3.882-11.018,7.773-10.523,4.569.58,2.732,3.985-.506,6.006-2.376,1.486-5.293,3.6-6.679,4.62a19.767,19.767,0,0,0,3.644.292c3.191-.076,4.749.865,5.353,1.37",
    transform: "translate(-1351.078 -1266.98)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20479",
    "data-name": "Path 20479",
    d: "M937.671,1050.931l-9.827,116.838s-1.029,7.083,4.239,7.1c8.662.021,43.113,0,43.113,0s-6.519-1.474-6.44-4.791c.093-3.91,11.485-120.248,11.485-120.248Z",
    transform: "translate(-744.597 -842.56)",
    fill: "#7599ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20480",
    "data-name": "Path 20480",
    d: "M989.952,1164.173c-1.7,0-35.057.062-43.493-.047-3.676-.046-4.321-3.269-4.351-5.354a10.429,10.429,0,0,1,.112-1.739l.255-3.037.651-7.74.575-6.838.739-8.787.623-7.417,6.982-83.022,42.571-1.1s-4.8,48.687-8.192,84.126c-.379,3.949-.739,7.735-1.073,11.269q-.163,1.693-.313,3.306c-.315,3.353-.6,6.432-.853,9.151-.132,1.433-.254,2.765-.364,3.984-.433,4.779-.687,7.831-.69,8.411a4.909,4.909,0,0,0,.083.946c.7,3.724,6.1,3.892,6.736,3.892",
    transform: "translate(-756.109 -833.942)",
    fill: "#90aff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20481",
    "data-name": "Path 20481",
    d: "M454.288,733.388l23.935,96.143L481.5,842.7l11.148,44.781H699.759L658.67,733.388Z",
    transform: "translate(-364.599 -588.597)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20482",
    "data-name": "Path 20482",
    d: "M440.8,733.387l-3.317,1.106,37.268,156.331,4.41-3.344Z",
    transform: "translate(-351.113 -588.596)",
    fill: "#90aff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20483",
    "data-name": "Path 20483",
    d: "M626.252,1517.232H832.089l5.684-3.344H630.663Z",
    transform: "translate(-502.613 -1215.004)",
    fill: "#7599ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26245",
    "data-name": "Rectangle 26245",
    width: 44.567,
    height: 2.118,
    transform: "translate(195.923 330.231)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20484",
    "data-name": "Path 20484",
    d: "M989.414,1530.822l-.23,1.619-41.912,8.467.575-6.838.274-3.248Z",
    transform: "translate(-760.254 -1228.595)",
    fill: "#5888dd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_123811",
    "data-name": "Group 123811",
    transform: "translate(185.999 316.981)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123810",
    "data-name": "Group 123810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123809",
    "data-name": "Group 123809",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20485",
    "data-name": "Path 20485",
    d: "M989.958,1618.8c-1.7.005-35.057.062-43.493-.047-3.676-.046-4.321-3.269-4.351-5.354l41.715-7.848c-.433,4.779-.687,7.831-.69,8.411a4.909,4.909,0,0,0,.083.946c.7,3.724,6.1,3.892,6.736,3.892",
    transform: "translate(-942.114 -1605.555)",
    fill: "#5888dd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_20486",
    "data-name": "Path 20486",
    d: "M454.286,733.387H658.668l33.161,123.841H485.116Z",
    transform: "translate(-364.597 -588.596)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20487",
    "data-name": "Path 20487",
    d: "M716.6,878.831H525.239L518.4,851.589l-2.646-10.541-1.079-4.3-7.028-28-.364-1.457-3.715-14.8-1.662-6.621-1.418-5.648-3.324-13.24H685.77l3.65,13.24,1.556,5.648L692.8,792.5l12.025,43.62v0l1.02,3.7.474,1.716,8.3,30.115Z",
    transform: "translate(-399.011 -615.565)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20488",
    "data-name": "Path 20488",
    d: "M689.424,780.229H500.493l-3.323-13.241H685.775Z",
    transform: "translate(-399.014 -615.563)",
    fill: "#607cf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20489",
    "data-name": "Path 20489",
    d: "M536.481,790.569a1.251,1.251,0,0,1,1.243-1.655,2.261,2.261,0,0,1,2.068,1.655,1.251,1.251,0,0,1-1.242,1.655,2.261,2.261,0,0,1-2.068-1.655",
    transform: "translate(-430.524 -633.16)",
    fill: "#e9f3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20490",
    "data-name": "Path 20490",
    d: "M564.339,790.569a1.251,1.251,0,0,1,1.243-1.655,2.261,2.261,0,0,1,2.068,1.655,1.251,1.251,0,0,1-1.243,1.655,2.261,2.261,0,0,1-2.068-1.655",
    transform: "translate(-452.882 -633.16)",
    fill: "#e9f3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20491",
    "data-name": "Path 20491",
    d: "M594.336,790.569a1.251,1.251,0,0,1,1.243-1.655,2.261,2.261,0,0,1,2.068,1.655,1.251,1.251,0,0,1-1.242,1.655,2.261,2.261,0,0,1-2.068-1.655",
    transform: "translate(-476.957 -633.16)",
    fill: "#e9f3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20492",
    "data-name": "Path 20492",
    d: "M1216.97,74.445c7.735-9.081,19.662-27.323,27.692-36.665a2.962,2.962,0,0,0-2.257-4.89h-14.612l13.783-31.165A1.222,1.222,0,0,0,1239.48.5l-33.326,44.6a1.844,1.844,0,0,0,1.7,2.934L1224.4,46l-9.842,27.035a1.419,1.419,0,0,0,2.412,1.41",
    transform: "translate(-967.727 0.002)",
    fill: "#f77d48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20493",
    "data-name": "Path 20493",
    d: "M840.121,420.067c1.74-8.925,2.839-25.5,4.677-34.71a2.258,2.258,0,0,0-3.328-2.4l-9.705,5.466-2.5-25.855a.931.931,0,0,0-1.85-.03l-5.45,42.09a1.406,1.406,0,0,0,2.229,1.312l10.225-7.541,3.575,21.637a1.082,1.082,0,0,0,2.13.034",
    transform: "translate(-659.674 -290.307)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20494",
    "data-name": "Path 20494",
    d: "M901.6,627.776,735.32,641.785a16.644,16.644,0,0,1-16.594-23.376l70.447-157.66a16.644,16.644,0,0,1,29.042-2.447l95.833,143.651A16.645,16.645,0,0,1,901.6,627.776",
    transform: "translate(-575.649 -361.874)",
    fill: "#e6efff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20495",
    "data-name": "Path 20495",
    d: "M876.45,608.395,710.171,622.4a22.956,22.956,0,0,1-22.886-32.24L757.731,432.5a22.956,22.956,0,0,1,40.056-3.375L893.62,572.78a22.956,22.956,0,0,1-17.169,35.615M777.823,431.573a10.2,10.2,0,0,0-8.566,6.081L698.81,595.314a10.332,10.332,0,0,0,10.3,14.511l166.28-14.009a10.332,10.332,0,0,0,7.728-16.03L787.286,436.135a10.2,10.2,0,0,0-9.463-4.562",
    transform: "translate(-549.969 -336.204)",
    fill: "#f77d48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20496",
    "data-name": "Path 20496",
    d: "M1099.695,768.523a15.212,15.212,0,0,1,.647-6.039,13.94,13.94,0,0,1,2.846-5,14.941,14.941,0,0,1,4.777-3.542,18.631,18.631,0,0,1,6.542-1.679,19.058,19.058,0,0,1,6.781.557,14.855,14.855,0,0,1,5.353,2.688,13.952,13.952,0,0,1,3.641,4.451,15.24,15.24,0,0,1,1.649,5.845,14.88,14.88,0,0,1-.651,5.99,14.047,14.047,0,0,1-2.849,4.949,14.813,14.813,0,0,1-4.827,3.546,19.057,19.057,0,0,1-6.592,1.684,18.632,18.632,0,0,1-6.731-.561,14.9,14.9,0,0,1-5.3-2.693,14.03,14.03,0,0,1-3.637-4.4,14.849,14.849,0,0,1-1.644-5.8m25.707-30.081-23.951,2.018-10.288-81.552,30.738-2.59Z",
    transform: "translate(-875.737 -526.742)",
    fill: "#f77d48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20497",
    "data-name": "Path 20497",
    d: "M611.385,1083s.521-1.172.859-1.728,1.78-2.182,2.026-1.813,1.228,2.847.706,3.541.034,1.9-2.561,2.633Z",
    transform: "translate(-490.681 -866.302)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20498",
    "data-name": "Path 20498",
    d: "M465.311,1060.115s13.284,11.089,18.464,10.063c4.05-.8,10.454-2.834,10.454-2.834a4.086,4.086,0,0,1,1.212,3.534s-8.158,7.676-13.971,7.726c-9.085.078-13.37-4.5-13.37-4.5Z",
    transform: "translate(-373.446 -850.818)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20499",
    "data-name": "Path 20499",
    d: "M347.3,1644.424s.386,6.221,1.589,6.31c.16.012,6.1.012,6.1.012l7.588-.044a2.462,2.462,0,0,0-2.268-2.215c-2.218-.387-5.931-1.945-7.274-4.877-1.414-3.084-5.74.814-5.74.814",
    transform: "translate(-278.737 -1318.162)",
    fill: "#113c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20500",
    "data-name": "Path 20500",
    d: "M345.088,1342.537a15.825,15.825,0,0,0,4.108.771,15.09,15.09,0,0,0,3.835-.547,104.993,104.993,0,0,1,2.824-13.453c1.253-4.85,3.042-11.087,5.588-18.836,7.039-21.417,9.179-33.946,9.374-35.132.01-.062.015-.094.015-.094l-.023-.01-21.639-9.5s2.675,29.517-.738,40.847a47.738,47.738,0,0,0-1.238,5.428c-2.155,12.307-2.105,30.527-2.105,30.527",
    transform: "translate(-276.958 -1015.843)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20501",
    "data-name": "Path 20501",
    d: "M369.363,1329.308c1.253-4.85,3.042-11.087,5.588-18.836,7.038-21.417,9.179-33.946,9.374-35.132,0-.035,0-.069-.008-.1l-21.639-9.5s2.675,29.517-.738,40.847c-.478,1.583,7.423,22.726,7.423,22.726",
    transform: "translate(-290.466 -1015.843)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20502",
    "data-name": "Path 20502",
    d: "M432.911,1644.424s.386,6.221,1.589,6.31c.16.012,6.1.012,6.1.012l7.588-.044a2.462,2.462,0,0,0-2.268-2.215c-2.218-.387-5.931-1.945-7.274-4.877-1.414-3.084-5.74.814-5.74.814",
    transform: "translate(-347.442 -1318.162)",
    fill: "#15447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20503",
    "data-name": "Path 20503",
    d: "M401.525,1269.258a308.048,308.048,0,0,1-3.028,42.612c-3.309,23.485-2.188,33.454-2.188,33.454a22.507,22.507,0,0,1-3.191.811,14.483,14.483,0,0,1-4.735-.548s-4.737-23.494-3.379-35.249S378.518,1270,378.518,1270Z",
    transform: "translate(-303.788 -1018.671)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20504",
    "data-name": "Path 20504",
    d: "M417.334,1004.1l4.224,2.77,3.848-1.088c.7-1,.89-2.937.9-4.613a28.7,28.7,0,0,0-.151-3.072l-5.7-2.515-2.126-.937c.006.033.165,1.746.188,2a14.547,14.547,0,0,1-1.183,7.459",
    transform: "translate(-334.941 -798.275)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20505",
    "data-name": "Path 20505",
    d: "M387.135,1086.093c-5.257,5.076-25.155,4.223-26.381-1.37s1.337-47.61,10.318-50.25c1.864-.548,11.827,2.672,11.827,2.672a63.166,63.166,0,0,1,2.589,9.3c.2,1.013.78,11.751,1.215,21.8.2,4.7.374,9.246.462,12.576a36.255,36.255,0,0,1-.029,5.279",
    transform: "translate(-289.301 -830.189)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20506",
    "data-name": "Path 20506",
    d: "M424.827,1000.527c1.156,1.955,5.213,3.665,7.362,4.449a28.7,28.7,0,0,0-.151-3.072l-5.7-2.516c-1.26-.017-2.027.265-1.512,1.138",
    transform: "translate(-340.824 -802.081)",
    fill: "#fca56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20507",
    "data-name": "Path 20507",
    d: "M420.842,948.94s-9.182,2.864-10.878-2.881-4.023-9.246,1.768-11.317,7.582-.217,8.615,1.563,2.84,11.743.5,12.636",
    transform: "translate(-327.479 -749.463)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20508",
    "data-name": "Path 20508",
    d: "M403.747,923s-.586,6.686-1.968,6.4-2.9-.911-2.7,1.1-1.344,5.471-3.338,5.462c-4.276-.018-8.922-10.991-7.752-13.071,3.378-6,20.643-7.215,15.761.109",
    transform: "translate(-311.239 -736.71)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20509",
    "data-name": "Path 20509",
    d: "M423.567,1024c-.118-.05-6.836-3.063-7.621-2.8s-1.765,2.659-1.765,2.659l11.828,2.674a5.876,5.876,0,0,0-2.442-2.529",
    transform: "translate(-332.41 -819.572)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20510",
    "data-name": "Path 20510",
    d: "M506.152,1185.649,468.5,1221.1c-.738.695-1.669.916-2.068.492l-1.271-1.35c-.4-.425-.122-1.34.616-2.035l37.654-35.451c.738-.7,1.669-.916,2.068-.492l1.271,1.35c.4.425.122,1.34-.616,2.035",
    transform: "translate(-373.177 -948.679)",
    fill: "#1f4d84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20511",
    "data-name": "Path 20511",
    d: "M485.023,1289.295,468.5,1304.852c-.738.695-1.669.916-2.068.492l-1.271-1.35c-.4-.424-.123-1.34.616-2.035L482.3,1286.4Z",
    transform: "translate(-373.178 -1032.43)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20512",
    "data-name": "Path 20512",
    d: "M624.5,977.508a29.513,29.513,0,1,0,48.917-29.659q-.227-.226-.464-.447A29.514,29.514,0,0,0,624.5,977.508m8.435-27.239a27.184,27.184,0,1,1,1.171,38.425,27.152,27.152,0,0,1-1.171-38.425",
    transform: "translate(-500.178 -753.923)",
    fill: "#1f4d84"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_123814",
    "data-name": "Group 123814",
    transform: "translate(125.37 187.791)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123813",
    "data-name": "Group 123813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123812",
    "data-name": "Group 123812",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20513",
    "data-name": "Path 20513",
    d: "M682,996.994a27.184,27.184,0,1,1-1.172-38.423A27.07,27.07,0,0,1,682,996.994",
    transform: "translate(-635.017 -951.187)",
    fill: "#b3cff9"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_20514",
    "data-name": "Path 20514",
    d: "M418.221,1129.156c-20.747-14.784-19.022-34.512-19.022-34.512,7.583,4.277,15.108,13.734,18.56,21.937.2,4.7.374,9.246.462,12.576",
    transform: "translate(-320.357 -878.531)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20515",
    "data-name": "Path 20515",
    d: "M589.313,1228.7a5.66,5.66,0,0,0,2.65-1.637s.624.043-.1,1.374c-.061.111-.2.4-.3.6a.129.129,0,0,0,.109.186,13.809,13.809,0,0,1,3.32.069c.224.047.29.584.281.813a2.077,2.077,0,0,1-.437,1.417,7.252,7.252,0,0,1-2.622,1.373,7.925,7.925,0,0,1-4.056-.51l-1.328-.615.412-2.469.334.07c.53.111,1.186-.536,1.739-.672",
    transform: "translate(-470.973 -984.804)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20516",
    "data-name": "Path 20516",
    d: "M404.022,1048.272s-18.642,3.55,5.485,30.546c3.859,4.318,24.706,9.939,24.706,9.939s2.114-1.8,1.049-3.256c0,0-14.354-10.423-17.512-12.08-1.421-.746-5.514-16.637-7.83-20.464a10.442,10.442,0,0,0-5.9-4.685",
    transform: "translate(-318.742 -841.314)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20517",
    "data-name": "Path 20517",
    d: "M613.945,1080.806a9.5,9.5,0,0,0,.729-1.78,9.829,9.829,0,0,1,1.2-2.723c.127-.126.544.037.593.58a3.16,3.16,0,0,1-.3,1.179,13.285,13.285,0,0,0-.394,2.343c-.289.939-1.831.4-1.831.4",
    transform: "translate(-492.735 -863.778)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20518",
    "data-name": "Path 20518",
    d: "M1397.509,960.472a6.222,6.222,0,0,0-4.94.254c-8.405.345-8.717,8.961-7.73,12.167,1.386,4.5-3.518,8.054,1.92,9.876,6.31,2.115,11.6-.394,11.243.695,19.954,1.572,6.146-20.787-.493-22.992",
    transform: "translate(-1110.861 -770.548)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20519",
    "data-name": "Path 20519",
    d: "M1357.281,1101.623a22.021,22.021,0,0,1-2.247,3.4c-1.746,2.187-10.91-3-10.12-3.4s5.394-13.661,6.49-15.328,4.834-2.533,4.834-2.533Z",
    transform: "translate(-1079.352 -869.797)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20520",
    "data-name": "Path 20520",
    d: "M1527.144,1622.992s2.529,2.308,2.036,3.948-2.776,2.734-3.085,4.738-1.542,3.1-2.653,3.1h-5.294s-.817-1.411,1.157-1.836,2.718-2.781,2.595-4.968a38.551,38.551,0,0,1,.185-5.1l4.195-.972Z",
    transform: "translate(-1218.289 -1301.691)",
    fill: "#1f447f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20521",
    "data-name": "Path 20521",
    d: "M1397.374,1632.4s.91,9.779-.2,10.325l-14.211-.029s0-1.64,2.282-2,6.293-1.7,6.971-4.677,5.158-3.614,5.158-3.614",
    transform: "translate(-1109.928 -1310.119)",
    fill: "#1c3154"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20522",
    "data-name": "Path 20522",
    d: "M1406.955,1091.883a56.6,56.6,0,0,1,0,6.568c-.141,2.375-2.543,5.556-2.884,6.343-.855,1.974-1.82,2.295-1.82,2.295l-7.461,1.829-2.624.642-8.273-2.471s-3.768-10.518-2.255-16.439a45.508,45.508,0,0,1,3.825-10.032s5.622-1.264,15.541-.56Z",
    transform: "translate(-1108.577 -866.653)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20523",
    "data-name": "Path 20523",
    d: "M1457.111,1148.364c-.141,2.375-3.254,5.473-3.595,6.26-.855,1.974-1.82,2.295-1.82,2.295l-7.461,1.829-1.347-3.861s10.9-2.864,9.149-12.954Z",
    transform: "translate(-1158.022 -916.482)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20524",
    "data-name": "Path 20524",
    d: "M1379.433,1225.927s-4.1,12.753-4.36,17.095,7.832,61.68,8.158,63.681c.307,1.885,2.649,3.088,2.649,3.088a3.544,3.544,0,0,0,2.614.2,6.462,6.462,0,0,0,2.807-1.323s3.189-40.893,1.216-55.5a231.391,231.391,0,0,1-2-27.24Z",
    transform: "translate(-1103.59 -983.895)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20525",
    "data-name": "Path 20525",
    d: "M1420.025,1224s6.25,8.385,6.832,14.054.914,25.58,2.155,31.106,5.8,16.161,5.8,33.4a3.436,3.436,0,0,1-1.937,1.514,15.937,15.937,0,0,1-1.7.471,2.679,2.679,0,0,1-3-1.422c-3.083-6.208-12.9-26.23-13.408-30.386-.356-2.941-3.457-22.408-10.222-33.83-1.624-2.742,1-13.648,1-13.648Z",
    transform: "translate(-1126.824 -982.35)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20526",
    "data-name": "Path 20526",
    d: "M1392.924,1215.956a8.585,8.585,0,0,0,4.912,1.367c3.9.078,13.574-.995,13.574-.995a7.994,7.994,0,0,1,.412,2.468s-11.811,2.979-18.655.435a4.326,4.326,0,0,1-.243-3.275",
    transform: "translate(-1117.735 -975.892)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20527",
    "data-name": "Path 20527",
    d: "M1406.767,1223.527a2.031,2.031,0,1,1,1.781-2.016,1.911,1.911,0,0,1-1.781,2.016m0-3.441a1.449,1.449,0,1,0,1.191,1.426,1.326,1.326,0,0,0-1.191-1.426",
    transform: "translate(-1127.603 -978.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20528",
    "data-name": "Path 20528",
    d: "M1349.549,1175.031l-17.752.166-8.736-20.53,17.753-.166Z",
    transform: "translate(-1061.852 -926.571)",
    fill: "#b5453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20529",
    "data-name": "Path 20529",
    d: "M1408.446,1198.287l-1.3-1.6a4.577,4.577,0,0,0-1.52-.919c-.639-.134-1.988-.912-2.119-.692s1.037,1.783,1.037,1.783l.059.009c-1.34,1.008-4.724.118-5.142.53-.506.5.7,1.576,1.342,2.181s2.491,1.614,3.93,1.166c1.052-.327,2.708-.661,2.708-.661Z",
    transform: "translate(-1123.071 -959.104)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20530",
    "data-name": "Path 20530",
    d: "M1329.361,1170.282s1.115-1.268,1.826-.659-.186,3.6-.862,3.3-1.353-2.265-.964-2.637",
    transform: "translate(-1066.817 -938.573)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20531",
    "data-name": "Path 20531",
    d: "M1444.548,1080.923s5.082.561,8.729,7.187c2.876,5.226,7.793,14.859,5.937,17.58-.814,1.195-8.621,5.446-23.68,3.016a4.555,4.555,0,0,1,1.452-2.783s12.672-4.068,12.651-4.878c-.041-1.531-1.712-2.854-8.791-9.935-1.924-1.925,3.7-10.187,3.7-10.187",
    transform: "translate(-1152.12 -867.518)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20532",
    "data-name": "Path 20532",
    d: "M1430.177,1050.7c.174-.234-.05-.981-.329-2.371a25.976,25.976,0,0,1-.672-5.4l-.375.063-6.3,1.06s.143,1.684.147,3.271c0,.013,0,.026,0,.04.008,1.378-.372,3.46.093,3.732,2.387,1.4,6.763.507,7.435-.395",
    transform: "translate(-1141.661 -837.023)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20533",
    "data-name": "Path 20533",
    d: "M1422.5,1044.3s.125,2.375.129,3.961c3.525-.084,5.406-3.507,6.169-5.021Z",
    transform: "translate(-1141.661 -837.278)",
    fill: "#e8945b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20534",
    "data-name": "Path 20534",
    d: "M1403,1003.755s8.257-1.176,7.445-6.307-.292-8.738-5.6-8.2-6.018,2.653-6.164,4.432,2.148,10.253,4.317,10.079",
    transform: "translate(-1122.538 -793.897)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20535",
    "data-name": "Path 20535",
    d: "M1410.831,986.064s3.213,5.659,6.815,6,4.956-.828,4.956-.828a9.923,9.923,0,0,1-4.127-5.279s-6.4-3.027-7.644.109",
    transform: "translate(-1132.294 -790.246)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20536",
    "data-name": "Path 20536",
    d: "M1398.76,990.757a5.173,5.173,0,0,0-2.066,2.22,8.4,8.4,0,0,0-.363,4.887s-2.351-3.82-.81-6.438c1.633-2.776,3.239-.669,3.239-.669",
    transform: "translate(-1119.586 -794.539)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20537",
    "data-name": "Path 20537",
    d: "M472.532,1684.866H14.826a.574.574,0,0,1-.572-.572v-.33a.574.574,0,0,1,.572-.572H472.532a.574.574,0,0,1,.572.572v.33a.574.574,0,0,1-.572.572",
    transform: "translate(-11.44 -1351.043)",
    fill: "#233862"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/pageNotFound.313f0695ccf8de545b15a47197a50da1.svg";
export { ForwardRef as ReactComponent };